import { render, staticRenderFns } from "./NoPreview.vue?vue&type=template&id=65cbbdac&"
import script from "./NoPreview.vue?vue&type=script&lang=js&"
export * from "./NoPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports